module.exports = "/images/google.svg?ac4fc67d6dc9c5c82fda53cd281fcf5a";